/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { createMakeAndWithStyles } from 'tss-react';
import { useTheme } from '@mui/material/styles';
import { AppTheme } from '../models/Theme';


const { makeStyles } = createMakeAndWithStyles<AppTheme>({
  useTheme,
});

export const makeAppStyles = makeStyles;
